<script setup>
import AppIcon from "./AppIcon.vue";
const nav = [
  { to: "/", label: "Overview" },
  { to: "/project-types", label: "Project types" },
  { to: "/feasibility", label: "Feasibility" },
  { to: "/investors", label: "Investors" },
  { to: "/volunteers", label: "Volunteers" }
];
</script>

<template>
  <header class="ds-header" role="banner">
    <div class="ds-header-inner">
      <RouterLink class="ds-brand" to="/" aria-label="ScionCarbon Project Center home">
        <AppIcon name="logo" class="ds-brand-glyph" />
        <span class="ds-brand-text">
          <span class="ds-brand-word"><strong>Scion</strong>Carbon</span>
          <span class="ds-brand-sub">Project Center</span>
        </span>
      </RouterLink>

      <nav class="ds-nav" aria-label="Main">
        <RouterLink
          v-for="item in nav"
          :key="item.to"
          class="ds-nav-item"
          :to="item.to"
        >{{ item.label }}</RouterLink>
      </nav>

      <div class="ds-header-actions">
        <RouterLink class="ds-link-button" to="/contact">Contact</RouterLink>
        <RouterLink class="ds-link-button" to="/login">Login</RouterLink>
        <RouterLink class="ds-button ds-button-primary" to="/feasibility">Check feasibility</RouterLink>
      </div>
    </div>
  </header>
</template>
